import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import './AccountSettings.css';

export default function AccountSettings() {
  const { user, logout } = useAuth();
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  
  // Edit Product State
  const [userProducts, setUserProducts] = useState([]);
  const [editingProduct, setEditingProduct] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [editMessage, setEditMessage] = useState('');
  
  // COMMENTED: Affiliate-related state variables disabled
  // const [wishlistLink, setWishlistLink] = useState('');
  // const [associateId, setAssociateId] = useState('');
  // const [isAffiliateMember, setIsAffiliateMember] = useState(false);
  // const [isSaving, setIsSaving] = useState(false);
  // const [saveMessage, setSaveMessage] = useState('');

  // useEffect(() => {
  //   if (user) {
  //     // Load user's affiliate settings
  //     setWishlistLink(user.wishlistLink || '');
  //     setAssociateId(user.associateId || '');
  //     setIsAffiliateMember(user.isAffiliateMember || false);
  //   }
  // }, [user]);

  // COMMENTED: Affiliate-related functions disabled
  /*
  const generateAffiliateId = () => {
    // No auto-generation - user provides their own affiliate link
    setSaveMessage('Please enter your existing affiliate link manually');
    setTimeout(() => setSaveMessage(''), 3000);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setSaveMessage('Copied to clipboard!');
      setTimeout(() => setSaveMessage(''), 3000);
    });
  };

  const saveAffiliateSettings = async () => {
    if (isAffiliateMember && !wishlistLink.trim()) {
      setSaveMessage('Please enter your Amazon wishlist link to become an affiliate member');
      return;
    }

    if (isAffiliateMember && !associateId.trim()) {
      setSaveMessage('Please enter your Amazon associate ID');
      return;
    }

    setIsSaving(true);
    setSaveMessage('');

    try {
      // This would call your backend API to save affiliate settings
      const response = await fetch('/api/user/affiliate-settings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await user.getIdToken()}`
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          isAffiliateMember,
          wishlistLink: isAffiliateMember ? wishlistLink.trim() : '',
          associateId: isAffiliateMember ? associateId.trim() : ''
        })
      });

      if (response.ok) {
        setSaveMessage('Settings saved successfully!');
        if (isAffiliateMember && wishlistLink.trim()) {
          setSaveMessage('Affiliate member activated! Your products will be fetched soon.');
        }
        setTimeout(() => setSaveMessage(''), 3000);
      } else {
        throw new Error('Failed to save settings');
      }
    } catch (error) {
      console.error('Error saving affiliate settings:', error);
      setSaveMessage('Error saving settings');
      setTimeout(() => setSaveMessage(''), 3000);
    } finally {
      setIsSaving(false);
    }
  };
  */

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className={`account-settings ${darkMode ? "dark" : ""}`}>
      <div className="container">
        <h1>Account Settings</h1>
        
        <div className="settings-section">
          <h2 style={{marginBottom: '15px', fontSize: '18px', color: darkMode ? '#ccc' : '#333'}}>Profile Information</h2>
          <div className="info-item">
            <label style={{fontWeight: '600', color: darkMode ? '#ccc' : '#333', marginRight: '10px', fontSize: '14px'}}>Email:</label>
            <span style={{color: darkMode ? '#333' : '#333', fontWeight: '500'}}>{user?.email || 'Not available'}</span>
          </div>
        </div>

        {/* COMMENTED: Affiliate Settings functionality disabled */}
        {/* <div className="settings-section">
          <h2 style={{marginBottom: '15px', fontSize: '18px', color: darkMode ? '#ccc' : '#333'}}>Affiliate Settings</h2>
          
          <div className="affiliate-form">
            <div className="form-group">
              <label style={{fontWeight: '600', color: darkMode ? '#ccc' : '#333', marginBottom: '8px', fontSize: '14px', display: 'block'}}>
                <input
                  type="checkbox"
                  checked={isAffiliateMember}
                  onChange={(e) => setIsAffiliateMember(e.target.checked)}
                  style={{marginRight: '8px'}}
                />
                Become an Affiliate Member
              </label>
              <p style={{fontSize: '12px', color: darkMode ? '#aaa' : '#666', marginTop: '5px', marginBottom: '15px'}}>
                Share your wishlist products and earn commissions. Enable this option to submit your Amazon wishlist link and associate ID.
              </p>
            </div>

            {isAffiliateMember && (
              <>
                <div className="form-group">
                  <label style={{fontWeight: '600', color: darkMode ? '#ccc' : '#333', marginBottom: '8px', fontSize: '14px', display: 'block'}}>
                    Amazon Wishlist Link:
                  </label>
                  <input
                    type="url"
                    value={wishlistLink}
                    onChange={(e) => setWishlistLink(e.target.value)}
                    placeholder="https://www.amazon.in/hz/wishlist/ls/..."
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: `1px solid ${darkMode ? '#444' : '#ddd'}`,
                      borderRadius: '6px',
                      fontSize: '14px',
                      backgroundColor: darkMode ? '#2d2d2d' : '#fff',
                      color: darkMode ? '#fff' : '#333',
                      marginBottom: '15px'
                    }}
                  />
                  <p style={{fontSize: '12px', color: darkMode ? '#aaa' : '#666', marginTop: '5px'}}>
                    Enter your public Amazon wishlist link. Products will be automatically fetched and displayed on DoodleCart.
                  </p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: '600', color: darkMode ? '#ccc' : '#333', marginBottom: '8px', fontSize: '14px', display: 'block'}}>
                    Amazon Associate ID:
                  </label>
                  <input
                    type="text"
                    value={associateId}
                    onChange={(e) => setAssociateId(e.target.value)}
                    placeholder="your-associate-id-21"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: `1px solid ${darkMode ? '#444' : '#ddd'}`,
                      borderRadius: '6px',
                      fontSize: '14px',
                      backgroundColor: darkMode ? '#2d2d2d' : '#fff',
                      color: darkMode ? '#fff' : '#333',
                      marginBottom: '15px'
                    }}
                  />
                  <p style={{fontSize: '12px', color: darkMode ? '#aaa' : '#666', marginTop: '5px'}}>
                    Your Amazon associate tag (e.g., doodlecart-21). This will be used for all product links.
                  </p>
                </div>
              </>
            )}

            <div className="form-actions">
              <button
                onClick={saveAffiliateSettings}
                disabled={isSaving}
                className="save-btn"
                style={{
                  padding: '12px 24px',
                  background: isSaving ? '#ccc' : '#e74c3c',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: isSaving ? 'not-allowed' : 'pointer',
                  fontSize: '16px',
                  fontWeight: '600'
                }}
              >
                {isSaving ? 'Saving...' : 'Save Settings'}
              </button>
            </div>

            {saveMessage && (
              <div className="save-message" style={{
                marginTop: '12px',
                padding: '8px 12px',
                borderRadius: '4px',
                fontSize: '14px',
                backgroundColor: saveMessage.includes('success') || saveMessage.includes('activated') ? '#d4edda' : '#f8d7da',
                color: saveMessage.includes('success') || saveMessage.includes('activated') ? '#155724' : '#721c24'
              }}>
                {saveMessage}
              </div>
            )}
          </div>
        </div> */}

        <div className="settings-section">
          <h2 style={{marginBottom: '15px', fontSize: '18px', color: darkMode ? '#ccc' : '#333'}}>Preferences</h2>
          <div className="info-item">
            <label style={{fontWeight: '600', color: darkMode ? '#ccc' : '#333', marginRight: '10px', fontSize: '14px'}}>Theme:</label>
            <span style={{color: darkMode ? '#333' : '#333', fontWeight: '500'}}>{darkMode ? 'Dark' : 'Light'}</span>
          </div>
        </div>

        {/* Edit Products Section */}
        <div className="settings-section">
          <h2 style={{marginBottom: '15px', fontSize: '18px', color: darkMode ? '#ccc' : '#333'}}>Manage Your Products</h2>
          
          {userProducts.length === 0 ? (
            <p style={{color: darkMode ? '#aaa' : '#666', fontSize: '14px'}}>
              You haven't added any products yet. 
              <button 
                onClick={() => navigate('/add-product')}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#007bff',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  marginLeft: '5px',
                  fontSize: '14px'
                }}
              >
                Add your first product
              </button>
            </p>
          ) : (
            <div className="products-list">
              {userProducts.map((product) => (
                <div key={product.id} className="product-item" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '15px',
                  border: `1px solid ${darkMode ? '#444' : '#ddd'}`,
                  borderRadius: '8px',
                  marginBottom: '10px',
                  backgroundColor: darkMode ? '#2d2d2d' : '#f9f9f9'
                }}>
                  <div className="product-info" style={{flex: 1}}>
                    <h4 style={{margin: '0 0 5px 0', fontSize: '16px', color: darkMode ? '#fff' : '#333'}}>
                      {product.title}
                    </h4>
                    <p style={{margin: '0', fontSize: '14px', color: darkMode ? '#aaa' : '#666'}}>
                      ₹{product.price} • {product.category} • {product.platform}
                    </p>
                  </div>
                  <div className="product-actions" style={{display: 'flex', gap: '8px'}}>
                    <button
                      onClick={() => startEditingProduct(product)}
                      style={{
                        padding: '6px 12px',
                        background: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Edit
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Edit Product Modal */}
          {editingProduct && (
            <div className="edit-modal" style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}>
              <div className="edit-modal-content" style={{
                backgroundColor: darkMode ? '#2d2d2d' : 'white',
                padding: '30px',
                borderRadius: '12px',
                width: '90%',
                maxWidth: '500px',
                maxHeight: '80vh',
                overflowY: 'auto'
              }}>
                <h3 style={{margin: '0 0 20px 0', color: darkMode ? '#fff' : '#333'}}>
                  Edit Product
                </h3>
                
                <div className="edit-form">
                  <div className="form-group" style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: darkMode ? '#ccc' : '#333'}}>
                      Title
                    </label>
                    <input
                      type="text"
                      value={editingProduct.title}
                      onChange={(e) => setEditingProduct({...editingProduct, title: e.target.value})}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: `1px solid ${darkMode ? '#555' : '#ddd'}`,
                        borderRadius: '4px',
                        backgroundColor: darkMode ? '#1a1a1a' : 'white',
                        color: darkMode ? '#fff' : '#333'
                      }}
                    />
                  </div>

                  <div className="form-group" style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: darkMode ? '#ccc' : '#333'}}>
                      Price (₹)
                    </label>
                    <input
                      type="number"
                      value={editingProduct.price}
                      onChange={(e) => setEditingProduct({...editingProduct, price: parseFloat(e.target.value) || 0})}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: `1px solid ${darkMode ? '#555' : '#ddd'}`,
                        borderRadius: '4px',
                        backgroundColor: darkMode ? '#1a1a1a' : 'white',
                        color: darkMode ? '#fff' : '#333'
                      }}
                    />
                  </div>

                  <div className="form-group" style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: darkMode ? '#ccc' : '#333'}}>
                      Category
                    </label>
                    <input
                      type="text"
                      value={editingProduct.category}
                      onChange={(e) => setEditingProduct({...editingProduct, category: e.target.value})}
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: `1px solid ${darkMode ? '#555' : '#ddd'}`,
                        borderRadius: '4px',
                        backgroundColor: darkMode ? '#1a1a1a' : 'white',
                        color: darkMode ? '#fff' : '#333'
                      }}
                    />
                  </div>

                  <div className="form-group" style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: darkMode ? '#ccc' : '#333'}}>
                      Rating (0-5)
                    </label>
                    <input
                      type="number"
                      value={editingProduct.rating}
                      onChange={(e) => setEditingProduct({...editingProduct, rating: parseFloat(e.target.value) || 0})}
                      min="0"
                      max="5"
                      step="0.1"
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: `1px solid ${darkMode ? '#555' : '#ddd'}`,
                        borderRadius: '4px',
                        backgroundColor: darkMode ? '#1a1a1a' : 'white',
                        color: darkMode ? '#fff' : '#333'
                      }}
                    />
                  </div>

                  <div className="form-group" style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: darkMode ? '#ccc' : '#333'}}>
                      Image URL
                    </label>
                    <input
                      type="url"
                      value={editingProduct.image}
                      onChange={(e) => setEditingProduct({...editingProduct, image: e.target.value})}
                      placeholder="Paste image URL here"
                      style={{
                        width: '100%',
                        padding: '8px 12px',
                        border: `1px solid ${darkMode ? '#555' : '#ddd'}`,
                        borderRadius: '4px',
                        backgroundColor: darkMode ? '#1a1a1a' : 'white',
                        color: darkMode ? '#fff' : '#333'
                      }}
                    />
                  </div>
                </div>

                {editMessage && (
                  <div style={{
                    margin: '15px 0',
                    padding: '10px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    backgroundColor: editMessage.includes('success') ? '#d4edda' : '#f8d7da',
                    color: editMessage.includes('success') ? '#155724' : '#721c24'
                  }}>
                    {editMessage}
                  </div>
                )}

                <div className="modal-actions" style={{
                  display: 'flex',
                  gap: '10px',
                  justifyContent: 'flex-end',
                  marginTop: '20px'
                }}>
                  <button
                    onClick={cancelEditing}
                    disabled={editLoading}
                    style={{
                      padding: '10px 20px',
                      background: '#6c757d',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: editLoading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={saveProductEdit}
                    disabled={editLoading}
                    style={{
                      padding: '10px 20px',
                      background: editLoading ? '#ccc' : '#007bff',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: editLoading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {editLoading ? 'Saving...' : 'Save Changes'}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="settings-section">
          <h2 style={{marginBottom: '15px', fontSize: '18px', color: darkMode ? '#ccc' : '#333'}}>Account Actions</h2>
          <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
            <button
              onClick={handleLogout}
              className="logout-btn"
              style={{
                padding: '12px 24px',
                background: '#e74c3c',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600',
                transition: 'background-color 0.3s ease'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#c0392b'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#e74c3c'}
            >
              Logout
            </button>
            <p className="note" style={{color: darkMode ? '#aaa' : '#666', fontSize: '13px', textAlign: 'center', padding: '10px', background: darkMode ? '#2d2d2d' : '#f8f9fa', borderRadius: '6px', margin: '0'}}>More account management features coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
}
